import React, { memo, useCallback, useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Button, Modal } from 'antd';

import eduzzAccountsService from 'v2/services/eduzzAccount';
import { fidcService } from 'v2/services/fidc';

const ModalFidc = memo(() => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(prev => !prev), []);

  const validateUser = useCallback(async (): Promise<void> => {
    if (!user) return;

    try {
      const result = await fidcService.validateCustomerReject(user.id);
      if (result?.data && !Array.isArray(result?.data)) toggle();
    } catch (err) {}
  }, [toggle, user]);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  return (
    <Modal
      open={open}
      onCancel={toggle}
      title='Comunicado importante para você!'
      footer={
        <div className='flex w-full justify-end gap-2'>
          <Button type='primary' onClick={toggle}>
            Entendi
          </Button>
        </div>
      }
    >
      <p className='mb-2!'>
        Notamos que há <b>irregularidades</b> em seu cadastro e para que você continue vendendo com a Eduzz é necessário
        realizar a <b>regularização do seu CPF e/ou CNPJ junto a Receita Federal.</b>
      </p>
      <p className='mb-2!'>
        Para que possamos continuar nossa parceria juntos, pedimos que <b>até dezembro</b> deste ano você regularize
        seus dados cadastrais com a Receita Federal, para evitar qualquer tipo de problema. Combinado?
      </p>
      <br />
      <p className='mb-0!'>
        Conte sempre com a gente.
        <br />
        <br />
        Eduzz.
      </p>
    </Modal>
  );
});

export default ModalFidc;
